/** 从路由 query 取值（重复 key 时 Vue Router 可能给出数组） */
export function firstQueryString(raw: unknown): string | undefined {
  if (typeof raw === 'string') return raw
  if (Array.isArray(raw)) {
    const first = raw[0]
    return typeof first === 'string' ? first : undefined
  }
  return undefined
}

/** 仅允许站内相对路径，防止开放重定向（如 //evil.com） */
export function resolveInternalRedirectPath(raw: unknown, fallback = '/'): string {
  const v = (firstQueryString(raw) ?? '').trim()
  if (!v) return fallback
  if (v === '/login' || v.startsWith('/login?')) return fallback
  if (!v.startsWith('/') || v.startsWith('//')) return fallback
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(v)) return fallback
  return v
}
